import React from "react";
import { createContext } from "react";
import { ProcessedResponse, Response, User } from "../types";

export interface IContextActions {
  type: "updateUser" | "updateSurveyId" | "updateCompanyId" | "setStartTime" | "setExpireTime" | "clearContext" | "setUserResponses";
  payload: ProcessedResponse[] | User | Date | {};
}

export interface IContextState {
  user: User & { processedResponses: ProcessedResponse[] };
  surveyId: number | null;
  companyId: number | null;
  startTime: Date;
  expireTime: Date;
}

export const initalSurveyContextState: IContextState = {
  user: {
    survey_key: '',
    languge_id: null,
    age_id: null,
    years_experience_id: null,
    gender_id: null,
    processedResponses: [],
  },
  surveyId: null,
  companyId: null,
  startTime: new Date(),
  expireTime: new Date(0),
};

export const surveyContextReducer = (state: IContextState, action: IContextActions) => {
  switch (action.type) {
    case "updateUser":
      Object.assign(state.user, action.payload);
      return state;
    case "updateSurveyId":
      return {
        ...state,
        surveyId: action.payload,
      };
    case "updateCompanyId":
      return {
        ...state,
        companyId: action.payload,
      };
    case "setStartTime":
      if (action.payload instanceof Date) {
        state.startTime = action.payload;
      }
      return state;
    case "setExpireTime":
      if (action.payload instanceof Date) {
        state.expireTime = action.payload;
      }
      return state;
    case "clearContext":
      state = {
        user: {
          survey_key: null,
          languge_id: null,
          age_id: null,
          years_experience_id: null,
          gender_id: null,
          processedResponses: [],
        },
        surveyId: null,
        companyId: null,
        startTime: new Date(),
        expireTime: new Date(0),
      };
      return state;

    case "setUserResponses":
      state.user.processedResponses = action.payload as ProcessedResponse[];
      return state;
    default:
      return state;
  }
};

export interface IContextProps {
  contextState: IContextState;
  contextDispatch: React.Dispatch<IContextActions>;
}

const SurveyContext = createContext<IContextProps>({
  contextState: initalSurveyContextState,
  contextDispatch: () => {},
});

export const SurveyContextConsumer = SurveyContext.Consumer;
export const SurveyContextProvider = SurveyContext.Provider;
export default SurveyContext;
